<template>
  <div class="newsfeed">
    <post-form :entity-id="eventId" entity='Event' access-level='Public' @update-data="fetchPosts" :is-new="true" />

    <div class="newsfeed__list">
      <newsfeed-post
        v-for="post in postArray"
        :key="post.eventPostId"
        :post-data="post"
        :entity-id="eventId"
        access-level="Public"
        entity="Event"
        :is-user-logged-in="isUserLoggedIn"
        :editable="post.editable"
        @update-data="fetchPosts"
      />
    </div>

    <el-divider />
      <div class="newsfeed__pagination">
        <el-button @click="fetchPreviousPosts" :disabled="skip === 0">
          <el-icon><ArrowLeft /></el-icon>
        </el-button>
        <el-button @click="fetchNextPosts" :disabled="postArray?.length < limit">
          <el-icon><ArrowRight /></el-icon>
        </el-button>
      </div>
  </div>
</template>

<script>
import { getEventPosts } from '@/api/events.js';
import NewsfeedPost from '@/components/common/NewsfeedPost.vue';
import PostForm from '@/components/common/PostForm.vue';

export default {
  name: 'EventNewsfeed',
  props: {
    eventId: {
      type: Number,
      required: true,
    },
    isUserLoggedIn: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    NewsfeedPost,
    PostForm,
  },

  data() {
    return {
      postArray: [],
      skip: 0,
      limit: 10,
    };
  },

  computed: {
    currentUser() {
      return this.$store.state.user;
    },
  },

  methods: {
    async fetchPosts() {
      const { eventId, skip, limit } = this;
      const { data, success } = await getEventPosts({ eventId, skip, limit });

      if (success) {
        this.postArray = data.items;
        for (let i = 0; i < this.postArray.length; i++) {
          this.postArray[i].editable = this.postArray[i].userId === this.currentUser.id;
        }
      }
    },

    async fetchPreviousPosts() {
      if (this.skip >= this.limit) {
        this.skip -= this.limit;
        await this.fetchPosts();
      }
    },
    async fetchNextPosts() {
      this.skip += this.limit;
      await this.fetchPosts();
    },
  },
  created() {
    this.fetchPosts();
  },
};
</script>

<style lang="scss">
.newsfeed {
  &__list {
  }
  &__pagination {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin-top: var(--global-dimension-size-250);
    align-items: center;
  }
}
</style>
